import { render, staticRenderFns } from "./member-order.vue?vue&type=template&id=3dd1264c&scoped=true&"
import script from "./member-order.vue?vue&type=script&lang=js&"
export * from "./member-order.vue?vue&type=script&lang=js&"
import style0 from "./member-order.vue?vue&type=style&index=0&id=3dd1264c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd1264c",
  null
  
)

export default component.exports